module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Øland","short_name":"Øland","start_url":"/","background_color":"#FFFFFF","theme_color":"#4A6A93","display":"minimal-ui","icon":"static/logo/logo.svg","lang":"da","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"1947a4a1fbfbeafa26656c75de541f84"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
